<template>
  <md-button
    class="button"
    :disabled="disabled"
    :type="type"
    :to="to"
    :href="href"
    :target="target"
    @click="onClick"
  >
    <div v-if="loading">
      <md-progress-spinner
        md-mode="indeterminate"
        :md-diameter="20"
        :md-stroke="2"
      />
    </div>

    <slot />
  </md-button>
</template>

<script>
  export default {
    name: 'XButton',

    props: {
      type: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      to: {
        type: Object
      },
      href: {
        type: String
      },
      target: {
        type: String
      }
    },
    methods: {
      onClick (event) {
        if (!this.disabled && !this.loading) {
          this.$emit('click', event)
        }
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  /deep/ .md-progress-spinner {
    display: flex;

    > svg {
      margin: 0 !important;
    }
  }
</style>
